<template>
	<div class="operations-buttons-group" :class="[extraClasses]">
		<!-- Download Button -->
		<button-tertiary
		v-if="downloadUrl || multipleDownloadUrls"
		icon="download"
		buttonSize="small"
		buttonStyle="round"
		:iconColor="iconsColor"
		@clicked="multipleDownloadUrls ? showMultipleDownloadModal = true : downloadClickHandler()"/>
		<!-- Email Button -->
		<button-tertiary
		icon="letter"
		buttonSize="small"
		buttonStyle="round"
		:iconColor="iconsColor"
		@clicked="showSendEmailInfoModal = true"/>
		<!-- SMS Button -->
		<button-tertiary
		v-if="!notificationOnlyEmail"
		icon="chat"
		buttonSize="small"
		buttonStyle="round"
		:iconColor="iconsColor"
		@clicked="showSendSMSInfoModal = true"/>
		<!-- Link Button -->
		<button-tertiary
		v-if="operationId"
		icon="link"
		buttonSize="small"
		buttonStyle="round"
		:iconColor="iconsColor"
		@clicked="showShareLinkModal = true"/>
		<!-- ShareLinkModal -->
		<modal-centered-share-link
		v-if="showShareLinkModal"
		:operationId="operationId"
		:payload="shareLinkPayload"
		@hideMe="showShareLinkModal = false"/>
		<!-- Multiple Downloads Modal -->
		<modal-centered-multiple-download
		v-if="showMultipleDownloadModal"
		:multipleDownloadUrls="multipleDownloadUrls"
		@downloadFile="downloadLink = $event"
		@hideMe="showMultipleDownloadModal = false"/>
		<!-- Component to handle download logic based on platform -->
		<download-logic-component :downloadLink="downloadLink" @clearDownloadLink="downloadLink = null"/>
		<!-- Send to email Movement Details -->
		<modal-centered-send-info
		v-if="showSendEmailInfoModal || showSendSMSInfoModal "
		:emailAction="emailAction"
		:smsAction="smsAction"
		:sendType="showSendEmailInfoModal ? 'email' : 'sms'"
		:payload="sendPayload"
		@hideMe="[showSendEmailInfoModal = false, showSendSMSInfoModal = false]"/>
	</div>
</template>

<script setup>
import DownloadLogicComponent from '@/components/generic/DownloadLogicComponent'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import ModalCenteredSendInfo from '@/components/generic/modals/centered/sendInfo/Base'
import ModalCenteredMultipleDownload from '@/components/generic/modals/centered/MultipleDownload'
import ModalCenteredShareLink from '@/components/generic/modals/centered/ShareLink'

/* Vue */
import { ref } from 'vue'

/* Props
@iconsColor {String} - color for buttons icon
@notificationOnlyEmail {Boolean}
@emailAction {String} - action to send info by email
@smsAction {String} - action to send info by email
@sendPayload {Object} - payload for action when sending email/sms
@downloadUrl {String} - Receipt url for download button, used if not specify the type of download file
@multipleDownloadUrls {Object} - with:
	- downloadPDFUrl {String} - Receipt url for PDF download button
	- downloadExcelUrl {String} - Receipt url for Excel download button
@operationId {Number, String} - OperationId to generate shareLink
@shareLinkPayload {Object} with:
    queryParams {Object} - query params to add to request
    dataParams {Object} - data  params to add to request
@extraClasses {String} - Extra classes for our component
*/
const props = defineProps({
	iconsColor: String,
	notificationOnlyEmail: Boolean,
	emailAction: String,
	smsAction: String,
	sendPayload: Object,
	downloadUrl: String,
	multipleDownloadUrls: Object,
	operationId: [Number, String],
	shareLinkPayload: Object,
	extraClasses: String
})

const showSendEmailInfoModal = ref(false)
const showSendSMSInfoModal = ref(false)
const downloadLink = ref(null)
const showMultipleDownloadModal = ref(false)
const showShareLinkModal = ref(false)

const downloadClickHandler = () => {
	downloadLink.value = props.downloadUrl
}
</script>

<style lang="scss" scoped>
.operations-buttons-group {
	width: 100%;
	height: fit-content;

	display: flex;
	flex-direction: row;
	gap: 16px;

	@media only screen and (max-width: 360px) {
		gap: 8px;
	}
}
</style>
